import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useNavigation } from '@navigation';

interface RequestToCallWarningHelperResources {
	title: string;
	tryAgain: string;
	requestContract: string;
	back: string;
}

interface RequestToCallWarningHelperOutput {
	resources: RequestToCallWarningHelperResources;
	onClick: () => void;
}

export const useRequestToCallWarningHelper = (): RequestToCallWarningHelperOutput => {
	const t = useTranslation();
	const { navigate } = useNavigation();

	const resources: RequestToCallWarningHelperResources = {
		title: t('placeholders.requestToCallWarning.title'),
		tryAgain: t('placeholders.requestToCallWarning.button.tryAgain.title'),
		requestContract: t('placeholders.requestToCallWarning.button.newRequestContract.title'),
		back: t('general.back'),
	};

	const onClick = () => navigate('root');

	return { resources, onClick };
};
